var text_field_default = {
  "root": "SsZJX",
  "text": "sWpL8",
  "input": "dzgFK",
  "small": "WweQ6",
  "medium": "O6Bhc",
  "large": "fPZ4c",
  "webview": "II8it",
  "endAdornment": "IU-mU",
  "shown": "zVOn2",
  "value": "T17hb",
  "spinner": "mZJQu",
  "spin": "dj393"
};
export {
  text_field_default as default
};
//# sourceMappingURL=text-field-scss.js.map
